export default __webpack_public_path__ + "static/media/bbp-campaigns-modal-large.159f7220.png";